import React from 'react';
import { Text, Radio, Flex } from '@leverege/ui-elements';
import Loading from '../../../../components/Loading';
import TRFormDialog from './TRFormDialog';
import { deactivate } from '../../../../util/TheftRecovery';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const options = [{
  label: 'Vehicle recovered and added back to inventory',
  value: 'recovered'
}, {
  label: 'Vehicle is not salvageable but locator was recovered',
  value: 'recoveredNotSalvageable'
}, {
  label: 'Vehicle was not recovered',
  value: 'notRecovered'
}];
export default class DisableDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reason: null,
      loading: false
    };
  }
  onDisable = async () => {
    const {
      sharedProps: {
        item,
        actions
      },
      onClose,
      caseActions
    } = this.props;
    const {
      companyId
    } = actions?.match?.params || {};
    const {
      reason
    } = this.state;
    await deactivate({
      locatorId: item?.data?.locator?.id,
      locationId: item?.data?.location?.id,
      companyId,
      actions,
      caseActions,
      goToTheft: reason === 'recoveredNotSalvageable' || reason === 'notRecovered',
      closeReason: reason,
      onChange: this.onLoading,
      onClose
    });
  };
  onChange = ({
    data
  }) => {
    const {
      value
    } = data;
    this.setState({
      reason: value
    });
  };
  onLoading = ({
    data,
    value
  }) => {
    this.setState({
      [data]: value
    });
  };
  getLoadingScreen() {
    return /*#__PURE__*/_jsx(Loading, {
      message: "Deactivating Theft Recovery",
      loading: true
    });
  }
  render() {
    const {
      show,
      onClose,
      type = 'end',
      title = 'End Theft Recovery Mode',
      okay = 'Yes, End Theft Recovery',
      cancel = 'No, Keep Theft Recovery Active'
    } = this.props;
    const {
      reason,
      loading
    } = this.state;
    return /*#__PURE__*/_jsx(TRFormDialog, {
      show: show,
      okayDisabled: type === 'end' && reason == null || loading,
      onOkay: this.onDisable,
      onClose: onClose,
      title: title,
      okay: okay,
      cancel: cancel,
      children: /*#__PURE__*/_jsxs(Flex, {
        variant: "colM",
        children: [loading && this.getLoadingScreen(), type === 'end' ? /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx(Text, {
            children: "Ending Theft Recovery Mode will discontinue realtime tracking of your locator device."
          }), /*#__PURE__*/_jsx(Text, {
            variant: "subtitle",
            children: "Please indicate the result of Theft Recovery Mode"
          }), options.map(opt => /*#__PURE__*/_jsx(Radio, {
            variant: "theftRecovery",
            eventData: opt,
            label: opt.label,
            on: opt.value,
            value: reason,
            onChange: this.onChange
          }, opt.value))]
        }) : /*#__PURE__*/_jsx(Text, {
          children: "Are you sure you want to end the theft recovery mode request?"
        })]
      })
    });
  }
}